// extracted by mini-css-extract-plugin
export default {"drawer":"drawer_drawer__Sf0h1","close-btn-box":"drawer_close-btn-box__iHqsJ","backdrop":"drawer_backdrop__O5SIw"};